/**
 * orga-app-api - qschecks-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PruefantwortDetail { 
    beschreibung?: string;
    gewichtung?: number;
    icon?: string;
    ist_na: boolean;
    ist_ne: boolean;
    farbe?: string;
    antwort_id: string;
    kuerzel?: string;
    pruefplan_id: string;
    ist_aktiv?: boolean;
    reihenfolge?: number;
    mandant_id?: string;
    modified_on_utc?: Date;
}

